/** Frontmatter for the "waiver-priority-vs-faab" article; the Body lives in waiver-priority-vs-faab.jsx. */
const meta = {
  slug: 'waiver-priority-vs-faab',
  title: 'Winning the Waiver Wire: Priority vs. FAAB',
  category: 'Waivers',
  excerpt: 'Two leagues, two completely different games. Here is how to spend your waiver capital in each without going broke by Week 6.',
  readMinutes: 6,
  date: '2026-07-28',
};

export default meta;
